import { AlertTriangle } from "lucide-react";
import { Reveal } from "@/components/site/Reveal";

export const Safety = () => (
  <section className="section" data-testid="safety-section">
    <div className="wrap">
      <Reveal>
        <div className="safety">
          <div className="safety-head">
            <AlertTriangle size={16} aria-hidden="true" />
            Safety &amp; compliance
          </div>
          <p><b>WARNING:</b> Sharp edges. Wear safety goggles during installation.</p>
          <p className="es">ADVERTENCIA: Bordes afilados. Use lentes de seguridad durante la instalación.</p>
          <hr />
          <p>
            <b>WARNING:</b> Cancer and Birth Defects —{" "}
            <a href="https://www.p65warnings.ca.gov" target="_blank" rel="noopener noreferrer">www.P65Warnings.ca.gov</a>
          </p>
          <p className="es">ADVERTENCIA: Cáncer y daños reproductivos — www.P65Warnings.ca.gov</p>
        </div>
      </Reveal>
    </div>
  </section>
);
